export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";
export const SIGN_OUT = "SIGN_OUT";
export const CHECK_AUTH_STATUS = "CHECK_AUTH_STATUS";
export const CREATE_USER = "CREATE_USER";
export const FETCH_USER = "FETCH_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const SYNC_USER = "SYNC_USER";
export const SET_USER = "SET_USER";
export const FETCH_OR_CREATE_USER = "FETCH_OR_CREATE_USER";

export const CREATE_GAME = "CREATE_GAME";
export const CREATE_GAME_SUCCESS = "CREATE_GAME_SUCCESS";
export const UPDATE_GAME = "UPDATE_GAME";
export const DELETE_GAME = "DELETE_GAME";
export const FETCH_GAME = "FETCH_GAME";
export const SET_GAME = "SET_GAME";
export const SET_GAME_ATTR = "SET_GAME_ATTR";

export const CREATE_NEW_CATEGORY = "CREATE_NEW_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const SAVE_PENDING_CATEGORY = "SAVE_PENDING_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const SET_CATEGORIES = "SET_CATEGORIES";
export const SET_CATEGORY = "SET_CATEGORY";

export const UPDATE_PENDING_CATEGORY = "UPDATE_PENDING_CATEGORY";

export const CREATE_ENTRY = "CREATE_ENTRY";
export const UPDATE_ENTRY = "UPDATE_ENTRY";
export const DELETE_ENTRY = "DELETE_ENTRY";
export const FETCH_ENTRY = "FETCH_ENTRY";
export const SET_ENTRY = "SET_ENTRY";
export const SET_ENTRIES = "SET_ENTRIES";
export const SELECT_NOMINEE = "SELECT_NOMINEE";
export const SELECT_NOMINEE_SUCCESS = "SELECT_NOMINEE_SUCCESS";
export const FETCH_USER_ENTRIES = "FETCH_USER_ENTRIES";

export const CREATE_NOMINEE = "CREATE_NOMINEE";
export const UPDATE_NOMINEE = "UPDATE_NOMINEE";
export const DELETE_NOMINEE = "DELETE_NOMINEE";
export const SET_NOMINEES = "SET_NOMINEES";
export const TOGGLE_CORRECT_NOMINEE = "TOGGLE_CORRECT_NOMINEE";

export const UPDATE_PENDING_NOMINEE = "UPDATE_PENDING_NOMINEE";
export const SAVE_PENDING_NOMINEE = "SAVE_PENDING_NOMINEE";

export const OPEN_MODAL = "OPEN_MODAL";
export const CLOSE_MODAL = "CLOSE_MODAL";
export const UPDATE_SEARCH_FIELD = "UPDATE_SEARCH_FIELD";
export const UPDATE_NEW_GAME_NAME = "UPDATE_NEW_GAME_NAME";
export const UPDATE_NEW_GROUP_NAME = "UPDATE_NEW_GROUP_NAME";
export const UPDATE_NEW_ENTRY_NAME = "UPDATE_NEW_ENTRY_NAME";
export const UPDATE_VALUE_FIELD = "UPDATE_VALUE_FIELD";
export const SET_NEXT_LOCATION = "SET_NEXT_LOCATION";

export const SUBMIT_SEARCH = "SUBMIT_SEARCH";
export const SUBMIT_SEARCH_SUCCESS = "SUBMIT_SEARCH_SUCCESS";
export const SUBMIT_SEARCH_FAILURE = "SUBMIT_SEARCH_FAILURE";
export const SAVE_TITLE = "SAVE_TITLE";
export const SAVE_PERSON = "SAVE_PERSON";

export const CREATE_NEW_GAME = "CREATE_NEW_GAME";
export const UPDATE_PENDING_GAME = "UPDATE_PENDING_GAME";
export const SAVE_PENDING_GAME = "SAVE_PENDING_GAME";

export const CREATE_GROUP = "CREATE_GROUP";
export const SET_GROUP = "SET_GROUP";
export const SET_GROUP_ATTR = "SET_GROUP_ATTR";
export const CREATE_GROUP_SUCCESS = "CREATE_GROUP_SUCCESS";
export const FETCH_GROUP = "FETCH_GROUP";
export const FETCH_USER_GROUPS = "FETCH_USER_GROUPS";
export const SAVE_GROUP_VALUES = "SAVE_GROUP_VALUES";
export const SAVE_GROUP_VALUES_SUCCESS = "SAVE_GROUP_VALUES_SUCCESS";

export const SHOW_ALERT_BAR = "SHOW_ALERT_BAR";
export const HIDE_ALERT_BAR = "HIDE_ALERT_BAR";

export const CAPTURE_RANKINGS = "CAPTURE_RANKINGS";
export const UPDATE_ANSWERED_ORDER = "UPDATE_ANSWERED_ORDER";
